//
// Homepage functions
//

export default class Homepage {
  constructor() {

  }
}